import {
  EventType,
  State,
  Type,
  getCurrentVirtue,
  getMarkedVirtues,
  getUserEmail,
  initialState,
  marked,
  nextState,
} from "./state"
import {
  getCachedMarkedVirtues,
  getCachedUserEmail,
  storeJournalEntry,
} from "../../modules/database"
import {
  getLatestVirtueSchemaVersion,
  getVirtues,
} from "../../modules/VirtueSchema"
import { FirebaseApp } from "firebase/app"
import { Virtue } from "../../modules/virtue"
import { assertIsDefined } from "../../modules/helpers"
import { initialiseFirebaseApp } from "../../modules/firebase"
import { startAuthenticationListener } from "../../modules/auth"

const startApp = () => {
  const app = initialiseFirebaseApp()
  startAuthenticationListener(app)
  const initApp = (markedVirtues: string[], userEmail: string) => {
    const virtues = getVirtues(userEmail)
    let state = initialState(virtues, markedVirtues, userEmail)
    const eventHandler = (event: EventType) => {
      return function () {
        state = nextState(event, state)
        renderState(state, app)
      }
    }
    const nextHandler = eventHandler(EventType.NEXT_EVENT)
    const previousHandler = eventHandler(EventType.PREVIOUS_EVENT)
    const dotHandler = eventHandler(EventType.TOGGLE_DOT_EVENT)
    getNextButton().addEventListener("click", nextHandler)
    getPreviousButton().addEventListener("click", previousHandler)
    getDotBox().addEventListener("click", dotHandler)
    renderState(state, app)
  }
  const virtues = getCachedMarkedVirtues()
  const userEmail = getCachedUserEmail()
  initApp(virtues, userEmail)
}
addEventListener("DOMContentLoaded", startApp)

function renderState(state: State, app: FirebaseApp): void {
  const nextButton = getNextButton()
  const previousButton = getPreviousButton()
  switch (state.type) {
    case Type.INITIAL: {
      nextButton.innerText = "NEXT"
      previousButton.innerText = "CANCEL"
      break
    }
    case Type.LAST: {
      nextButton.innerText = "SUBMIT"
      previousButton.innerText = "PREVIOUS"
      break
    }
    case Type.REVIEW: {
      nextButton.innerText = "NEXT"
      previousButton.innerText = "PREVIOUS"
      break
    }
    case Type.CANCEL: {
      navigateToIndex()
      break
    }
    case Type.SUBMIT: {
      const today = new Date()
      const markedVirtues = getMarkedVirtues(state)
      const userEmail = getUserEmail(state)
      const virtueSchemaVersion = getLatestVirtueSchemaVersion(userEmail)
      const onError = () => {
        console.warn("failed to store journal entry")
      }
      storeJournalEntry(markedVirtues, today, virtueSchemaVersion, app)
        .then(navigateToIndex)
        .catch(onError)
    }
  }
  const virtue = getCurrentVirtue(state)
  renderVirtue(virtue)
  const dotted = marked(virtue, state)
  renderDot(dotted)
}

function renderVirtue(virtue: Virtue) {
  const virtueNameEl = getElement("virtue")
  virtueNameEl.innerText = virtue.name
  const virtueDescriptionEl = getElement("virtueDescription")
  virtueDescriptionEl.innerText = virtue.description
}

function renderDot(dotted: boolean) {
  const dotEl = getElement("dot")
  dotEl.style.visibility = dotted ? "visible" : "hidden"
}

function getNextButton(): HTMLElement {
  return getElement("next-btn")
}

function getPreviousButton(): HTMLElement {
  return getElement("prev-btn")
}

function getDotBox(): HTMLElement {
  return getElement("dotBox")
}

function getElement(id: string): HTMLElement {
  const el = document.getElementById(id)
  assertIsDefined(el)
  return el
}

function navigateToIndex(): void {
  window.location.href = "../../index.html"
}
